// Pagination.jsx
import React from "react";

export default function Pagination({ currentPage, totalPages, onPageChange }) {

console.log('Pagination', { currentPage, totalPages });
  if (totalPages <= 1) return null;

  // simple windowed pager: 1 ... [k-2] [k-1] k [k+1] [k+2] ... N
  const makeRange = () => {
    const pages = [];
    const push = p => pages.push(p);

    const addWindow = (start, end) => {
      for (let p = start; p <= end; p++) push(p);
    };

    const left = Math.max(1, currentPage - 2);
    const right = Math.min(totalPages, currentPage + 2);

    if (left > 1) { push(1); if (left > 2) push("...l"); }
    addWindow(left, right);
    if (right < totalPages) { if (right < totalPages - 1) push("...r"); push(totalPages); }

    return pages;
  };

  const pages = makeRange();

  return (
    <nav style={{
        display: "flex",
        gap: "20px",
        padding: "60px 0",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "30px"
    }}>
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        style={{display: "none"}}
      >
        Prev
      </button>
        {console.log('pages', pages)}
      {pages.map((p, idx) => (
          <span
            key={idx}
            onClick={() => onPageChange(p)}
            aria-current={p === currentPage ? "page" : undefined}
            style={{ 
                    fontWeight: p === currentPage ? "500" : "200",
                    fontFamily: p === currentPage ? "NeueHelvetica65Medium, Arial, sans-serif" : "NeueHelvetica45Light, Arial, sans-serif",
                    "cursor": p === currentPage ? "default" : "pointer"
                }}
          >
            {p}
          </span>
        )
      )}

      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        style={{display: "none"}}
      >
        Next
      </button>
    </nav>
  );
}